module.exports = __webpack_public_path__ + "static/media/tl.547e4215.svg";